import React, { useEffect, useState } from 'react';
import './FetchGSTRModal.less';
import { Button, Modal, Input, Typography, Spin } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { getSendOTP } from '@Src/apiServices/OrganisationProfileService';
import { getCompanyId } from '@Src/commons/Utils/authUtils';
import { getOTP } from '@Src/components/OrganisationProfile/OrganisationProfileAction';
import { TypeRequestOtp } from '@Src/components/OrganisationProfile/Type';
import { StyledDivider, NormalText } from '@Src/commons/StyledComponent';
import Color from '@Src/commons/Colors';
import { ShowNormalError } from '@Src/commons/Notifications/Errors';
import { getFDsErrorMessageFromError } from '@Src/commons/Utils';

const { Text } = Typography;

const { ERROR_RED, GRAY_9 } = Color;

function FetchGSTRModal({
  fetchGstrModalOpen,
  setFetchGstrModalOpen,
  setVerifyOtpModalOpen,
  selectedGSTIN,
  setRequestId,
  companyIdentifierId,
  username,
  setUserName,
}) {
  const [password, setPassword] = useState('');
  const [statusCode, setStatusCode] = useState(0);
  const [isPassword, setIsPassword] = useState(false);
  const [proceedClick, setProceedClick] = useState(false);
  const [loading, setLoading] = useState(false);
  const [usernameChange, setUsernameChange] = useState(false);
  const handleCancel = () => {
    setFetchGstrModalOpen(false);
  };

  const requestOTP = () => {
    setProceedClick(true);
    const baseRequestBody: TypeRequestOtp = {
      companyId: Number(getCompanyId()),
      companyIdentifierId,
      username,
      gstin: selectedGSTIN,
    };

    const requestBody = isPassword
      ? { ...baseRequestBody, password }
      : baseRequestBody;
    setLoading(true);
    getOTP(requestBody)
      .then((res) => {
        setRequestId(res?.data?.requestId);
        setFetchGstrModalOpen(false);
        setVerifyOtpModalOpen(true);
      })
      .catch((err) => {
        if (err?.message?.error) {
          setStatusCode(err?.code);
          ShowNormalError({
            text: err?.message?.error,
            buttonProp: null,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
    setUsernameChange(true);
  };

  const getStatusText = (statusCode: number) => {
    let alert = '';

    switch (statusCode) {
      case 102:
        alert = 'This username or password is Incorrect';
        break;
      case 103:
        alert = 'No records found for the given ID or combination of inputs';
        break;
      case 104:
        alert =
          'OTP entered is incorrect. You have exceeded the number of retrieval attempts. Please try after sometime.';
        break;
      case 105:
        alert = 'Missing Consent';
        break;
      case 106:
        alert = 'Multiple Records Exist';
        break;
      case 107:
        alert = 'Not Supported';
        break;
      case 108:
        alert = 'Internal Resource Unavailable';
        break;
      case 109:
        alert = 'Too many records Found';
        break;
      default:
        break;
    }

    return alert ? (
      <NormalText
        fontSize={12}
        fontWeight={400}
        color={Color.ERROR_RED}
        className="mt--8"
      >
        {alert}
      </NormalText>
    ) : (
      ''
    );
  };
  function Heading() {
    return (
      <div>
        <div className="fetch-gstr-modal-header">
          <div>Fetch GSTR Reports</div>
          <CloseOutlined onClick={() => setFetchGstrModalOpen(false)} />
        </div>
      </div>
    );
  }
  return (
    <div>
      <Modal
        className="fetch-gstr-modal"
        open={fetchGstrModalOpen}
        title={Heading()}
        width="400px"
        onCancel={handleCancel}
        footer={null}
        closable={false}
      >
        <div className="h-gap-12 p-16">
          <div className="enter-credentials">
            Enter your GSTIN login credentials.
          </div>
          <div className="h-gap-8">
            <div>GSTIN</div>
            <NormalText fontSize={14} color={Color.GRAY_9} fontWeight={700}>
              {selectedGSTIN}
            </NormalText>
          </div>
          <div className="h-gap-8">
            <div>Username</div>
            <Input
              placeholder="Enter Username"
              value={username}
              status={statusCode === 400 ? 'error' : ''}
              onChange={(event) => {
                setUserName(event.target.value.trim());
                setUsernameChange(false);
                setStatusCode(0);
              }}
            />
          </div>

          {(statusCode && statusCode === 424) ||
          (proceedClick && statusCode === 400) ? (
            <div>
              <div>Password</div>
              <Input.Password
                placeholder="Enter Password"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  setIsPassword(true);
                }}
              />
            </div>
          ) : (
            ''
          )}
          {usernameChange && statusCode !== 0 && getStatusText(statusCode)}
        </div>
        <StyledDivider />
        <div className="fetch-gstr-modal-footer">
          <div>
            <Button
              disabled={username.length === 0 || statusCode === 400}
              onClick={() => requestOTP()}
              type="primary"
              loading={loading}
            >
              Proceed
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
export default FetchGSTRModal;
